import React, { useEffect, useState } from 'react'
import Navber from './Navber.jsx'
import { useParams, useNavigate } from 'react-router-dom'
import api from "../Api.js";
import "../Styles/HotelDetails.css"
import img1 from "../Images/hotelimg.jpg"
import SafeComponent from './SafeComponent.jsx';
import MapWrapper from './Safemap.jsx';
import ImageOverlay from './ImageOverlay .jsx';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TextField, Button } from "@mui/material";
import dayjs from "dayjs";
import FullScreenSpin from "./Helping Component/Fullscreeenspinner.jsx"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import { showToast } from './PopupMessage.jsx';
import akashimg from "../Images/Akash Resume Pic.jpeg"
import humanImg from "../Images/human_icon.jpg"
import ImageLightbox from "../Components/Helping Component/ImageZoom.jsx";





function HotelDetails() {
  const [hotelDetails, setHotelDetails] = React.useState(null);
  const [hotelRooms, setHotelRooms] = React.useState([]);
  const [aminities, setAmenities] = React.useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [bookingID, setBookingID] = useState(null);
  const [roomID, setRoomID] = useState(null);
  const [roomImages, setRoomImages] = useState([]);
  const [infants, setInfants] = useState(0);
  const [children, setChildren] = useState(0);
  const [adults, setAdults] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [price, setPrice] = useState(0);
  const navigate = useNavigate();
  const [destination, setDestination] = useState("");
  const [checkIn, setCheckIn] = useState();
  const [checkOut, setCheckOut] = useState();
  const [availableRoom, setAvailableRoom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hotelimg, setHotelimg] = useState([]);
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  console.log("the id from hotel details is : ", id);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImages, setCurrentImages] = useState([]);


useEffect(() => {
  const fetchHotelDetails = async () => {
    try {
      setAccessToken(localStorage.getItem("accessToken") || null);
      const res = await api.get(`/hotels/${id}`);
      if (res.data.status === true) {
        setHotelDetails(res?.data?.data);
        setHotelimg(res?.data?.data?.image);
        setHotelRooms(res?.data?.data?.rooms || []);
        setRoomImages(res?.data?.data?.rooms?.images || []);
        setSelectedRoom(res?.data?.data?.rooms[0] || null);
        setAmenities(res?.data?.data?.amenities || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getReviews = async () => {
    try {
      const response = await api.get("/reviews");
      console.log("Reviews response:", response.data);
      if (response.data.status === true) {
        setReviews(response?.data?.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchHotelDetails();
  getReviews();
}, [id]);

console.log("reviews data:", reviews);
const hotelreviews = hotelDetails
  ? reviews.filter(r => r.hotel_id === hotelDetails.id)
  : [];







  const handleSearch = () => {
    console.log("Search Clicked:", { destination, checkIn, checkOut });
  };
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = hotelRooms.find(r => r.id.toString() === roomId);
    setRoomID(roomId);
    if (room) {
      setSelectedRoom(room);
    }
  };


  useEffect(() => {
    if (selectedRoom) {
          if (adults + children + infants > selectedRoom.max_guests) {
      showToast(`Maximum Guest: ${selectedRoom.max_guests} .`,"warning");
      return;
    }
      const infantPrice = Number(selectedRoom.infant_price || 0);
      const childPrice = Number(selectedRoom.child_price || 0);
      const adultPrice = Number(selectedRoom.adult_price || 1);


      const total =
        adults * adultPrice +
        children * childPrice +
        infants * infantPrice


      setTotalPrice(total);
    }
  }, [selectedRoom, infants, children, adults]);


  const BookNow = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.","warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.","warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(`The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`,"warning");
      return;
    }
    try {
      console.log("accessToken:", accessToken);
      if (!accessToken) {
        showToast("Please log in to book a room.","warning");
        navigate('/signup');
        return;
      }





      const bookingData = {
        hotel_id: id,
        room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),
        adults,
        children,
        infants,
        // total_price: totalPrice
      };
           if(bookingData.check_in >= bookingData.check_out){
          showToast("Please give right Date and Time...","warning");
          return
      }
      console.log("accessToken : ", accessToken)
      console.log("bookingData : ", bookingData)
      const res = await api.post('/bookings/hotel-room', bookingData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      });


      console.log("Booking response:", res.data);
      if (res.data.status === true) {
        setBookingID(res?.data?.data?.id);
        navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, { state: { bookingDetails: res?.data?.data,hotel:hotelDetails,Time:bookingData } });

      } else {
        alert(res.data.message || "Booking failed. Please try again.");
        return;

      }


    } catch (err) {
      console.log(err);
    }


  }
  const availability = async () => {
    if (!checkIn || !checkOut) {
      showToast("Please select check-in and check-out dates.","warning");
      return;
    }
    if (!selectedRoom) {
      showToast("Please select a room type.","warning");
      return;
    }
    if (adults + children + infants > selectedRoom.max_guests) {
      showToast(`The selected room can accommodate a maximum of ${selectedRoom.max_guests} guests.`,"warning");
      return;
    }
    try {
      console.log("accessToken:", accessToken);
      if (!accessToken) {
        showToast("Please log in to book a room.","warning");
        navigate(-1);
        return;
      }





      const bookingData = {
        hotel_id: id,
        // room_id: selectedRoom.id,
        check_in: dayjs(checkIn).format("YYYY-MM-DD HH:mm:ss"),
        check_out: dayjs(checkOut).format("YYYY-MM-DD HH:mm:ss"),

      };
      if(bookingData.check_in >= bookingData.check_out){
          showToast("Please give right Date and Time...","warning");
          return
      }
      console.log("accessToken : ", accessToken)
      console.log("bookingData : ", bookingData)
      setLoading(true);
      const res = await api.post('/check-room-availability', bookingData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      });


      console.log("Booking availability response:", res.data);
      if (res.data.status === true) {
        setAvailableRoom(res?.data?.data);
        setLoading(false);
        // setBookingID(res?.data?.data?.id);
        // navigate(`/hotel/reviewbooking/${res?.data?.data?.id}`, { state: { bookingDetails: res?.data?.data } });
        if (Array.isArray(availableRoom) && availableRoom.length > 0) {
          showToast(`${availableRoom.length} Types of room are available...`, "success");
        }


      } else {
        alert(res.data.message || "Booking failed. Please try again.");
        return;

      }


    } catch (err) {
      console.log(err);
    }


  }

  console.log(hotelDetails?.images)


  const [currentSlide, setCurrentSlide] = useState(0);

  // 2️⃣ references for the DOM
  const trackRef = React.useRef(null);
  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${currentSlide * 100}%)`;
    }
  }, [currentSlide]);

  // Autoplay carousel
  useEffect(() => {
    if (!hotelDetails?.images) return;
    const interval = setInterval(() => {
      setCurrentSlide((s) => (s + 1) % hotelDetails.images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [hotelDetails]);


const totalRatings = hotelreviews.reduce((sum, r) => sum + Number(r.rating || 0), 0);
const averageRating = hotelreviews.length > 0 ? (totalRatings / hotelreviews.length).toFixed(1) : "No ratings yet";

 const RatingsText = (averageRating) => { 
if (averageRating >= 0 && averageRating < 1) {
    return <span>Pore</span>;
  }
  else if (averageRating >= 1 && averageRating < 2) {
    return <span>Average</span>;
  }
  else if (averageRating >= 2 && averageRating < 3) {
    return <span>Good</span>;
  }
  else if (averageRating >= 3 && averageRating < 4) {
    return <span>Very Good</span>;
  }
  else if (averageRating >= 4 && averageRating <= 5) {
    return <span>Excellent</span>;
  }
  else {
    return <span>No ratings yet</span>;
  }
 }




 // Converts a JS Date to a local datetime string (YYYY-MM-DDTHH:mm)
const formatDateTimeLocal = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
};


const handleOpenGallery = (item) => {

    const Images = [item , ...hotelDetails?.gallery_images];

    setCurrentImages(Images);
    setLightboxOpen(true);
 
   
  
};
const handleOpenGallery1 = (item) => {
 


    // Extract only URLs
    const imageList = item.images?.map(img => img.image);
   

    // console.log("the images src are",images)

    setCurrentImages(imageList);
    setLightboxOpen(true);
 
   
  
};





  return (
    <div>

      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
            <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />
      
      <div className="hotelDetail-container" >
        <div className="hotelDetail-grid" style={{ backgroundColor: "#F9F6F1" }}>
          {/* Left Section */}
          <div className="hotelDetail-left animate-fadeIn">
            <div>

              <Carousel fade interval={2000} pause="hover" indicators={true}>
                {hotelDetails?.gallery_images?.map((photo) => (
                  <Carousel.Item key={photo.id}>
                    <img
                      src={photo}
                      alt={`Hotel ${photo.id}`}
                      className="d-block w-100 hotelDetail-image animate-zoomIn"
                      // onClick={() => navigate(`/hotel/gallery/${id}`)}
                      onClick={()=>handleOpenGallery(photo)}
                      
                      style={{ cursor: 'pointer', objectFit: 'cover' }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
              <h1 className="hotelDetail-title">{hotelDetails?.name}</h1>


            </div>

            <p className="hotelDetail-description">
              <SafeComponent html={hotelDetails?.description || "No description available."} style={{ margin: "0px" }} />
            </p>

            {/* Tags */}
            {/* Amenities */}
            <div className="hotelDetail-tags">
              {aminities.map((amenity, index) => (
                <span className="hotelDetail-tag animate-bounce" key={index}>{amenity?.name}</span>

              ))}

            </div>

            {/* Images */}
            <div>
              <h2 className="hotelDetail-amenitiesTitle">Choose Your best luxury</h2>
              <div className="hotelDetail-amenitiesList">
                
{hotelRooms?.map((room) => {
  const availability = availableRoom.find(a => a.room_id === room.id);

  return (
    <div
      key={room.id}
      className={`jr-room-card ${
        selectedRoom?.id === room.id ? "jr-room-card--active" : ""
      }`}
      onClick={() => setSelectedRoom(room)}
    >
      {/* Image */}
      <div className="jr-room-image" onClick={() => handleOpenGallery1(room)}>
        <img
          src={room?.images?.[0]?.image || "/placeholder-room.jpg"}
          alt={room?.name}
        />
        {availability?.available_rooms === 0 && (
          <span className="jr-room-badge">Sold Out</span>
        )}
        <span className='button_show'>show Images</span>
      </div>

      {/* Details */}
      <div className="jr-room-info">
        <h4 className="jr-room-title">{room?.name}</h4>

        <p className="jr-room-meta">
          👥 Max Guests: {room?.max_guests} &nbsp;|&nbsp;
          🛏 {room?.room_type}
        </p>

        <p className="jr-room-food">
          🍽️ Available Food:
          {room.breakfast ? " Breakfast" : ""}
          {room.lunch ? " Lunch" : ""}
          {room.dinner ? " Dinner" : ""}
          {!room.breakfast && !room.lunch && !room.dinner && " No Meals"}
        </p>
      </div>

      {/* Price & Availability */}
      <div className="jr-room-price">
        <span className="jr-room-amount">₹{room?.price_per_night}</span>
        <span className="jr-room-night">per night</span>

        {availability && (
          availability.available_rooms > 0 ? (
            <span className="jr-room-available">
              {availability.available_rooms} Rooms Available
            </span>
          ) : (
            <span className="jr-room-soldout-text">Sold Out</span>
          )
        )}
      </div>
    </div>
  );
})}



              </div>
              {loading && <FullScreenSpin />}

            </div>
          </div>

          {/* Right Section */}
          <div className="hotelDetail-right animate-fadeIn">
            {/* Booking Box */}
            <div className="hotelDetail-bookingBox animate-slideInRight">
              <h3 className="hotelDetail-bookingTitle">Join Cottage</h3>
              {hotelRooms?.filter(a => a.id === selectedRoom.id).map((room) => (
                <p className="hotelDetail-bookingSub">Maximum Guest Per {room.room_type} room: {room?.max_guests}</p>


              ))}
              {

                <p className="hotelDetail-price">
                  {totalPrice}/-{" "}
                  {/* <span className="hotelDetail-priceTax">+250 taxes per night</span> */}
                </p>

              }



<div className="hotelDetail-dateInputs">
  {/* Room Type */}
  <select className="hotelDetail-selectRoomType" onChange={handleRoomChange} required>
    {hotelRooms.map((room) => (
      <option key={room.id} value={room.id}>
        {room.room_type}
      </option>
    ))}
  </select>

  {/* Infants */}
  <select
    className="hotelDetail-selectRoomType"
    onChange={(e) => setInfants(Number(e.target.value))}
    required
  >
    <option disabled>Select Infant</option>
    {[0, 1, 2, 3, 4, 5].map((n) => (
      <option key={n} value={n}>
        {n}
      </option>
    ))}
  </select>

  {/* Children */}
  <select
    className="hotelDetail-selectRoomType"
    onChange={(e) => setChildren(Number(e.target.value))}
    required
  >
    <option disabled>Select Child</option>
    {[0, 1, 2, 3, 4, 5].map((n) => (
      <option key={n} value={n}>
        {n}
      </option>
    ))}
  </select>

  {/* Adults */}
  <select
    className="hotelDetail-selectRoomType"
    onChange={(e) => setAdults(Number(e.target.value))}
    required
  >
    <option disabled>Select Adult</option>
    {[1, 2, 3, 4, 5].map((n) => (
      <option key={n} value={n}>
        {n}
      </option>
    ))}
  </select>

  {/* ✅ Check-in Date & Time */}
  <div className="mui-input">
    <input
      type="datetime-local"
      id="checkin"
      value={checkIn ? formatDateTimeLocal(checkIn) : ""}
      min={formatDateTimeLocal(new Date())}
      onChange={(e) => setCheckIn(new Date(e.target.value))}
      required
    />
    <label htmlFor="checkin">Check-in Date & Time</label>
  </div>

  {/* ✅ Check-out Date & Time */}
  <div className="mui-input">
    <input
      type="datetime-local"
      id="checkout"
      value={checkOut ? formatDateTimeLocal(checkOut) : ""}
      min={checkIn ? formatDateTimeLocal(checkIn) : formatDateTimeLocal(new Date())}
      onChange={(e) => setCheckOut(new Date(e.target.value))}
      required
    />
    <label htmlFor="checkout">Check-out Date & Time</label>
  </div>
</div>






              <button className="hotelDetail-bookBtn" onClick={BookNow}>Book Now</button>
              <button className="hotelDetail-bookBtn" onClick={availability} style={{ marginLeft: "5px", backgroundColor: "blue" }}>Check availability</button>
              {/* <p className="hotelDetail-moreOptions">8 more options</p> */}
            </div>

            {/* Review Box */}
            <div className="hotelDetail-reviewBox animate-slideInUp">
              <div className="hotelDetail-reviewHeader">
                <span className="hotelDetail-reviewScore">{totalRatings? (totalRatings/(hotelreviews.length)).toFixed(1): "0"}★</span>
                <span className="hotelDetail-reviewText">{RatingsText(averageRating)}</span>
                <span className="hotelDetail-reviewCount">({hotelreviews.length} Reviews)</span>
              </div>

              <div className="hotelDetail-reviewLocation">
                <p className="hotelDetail-locationSub" style={{ marginTop: "3px" }}>{hotelDetails?.land_mark}</p>

                <MapWrapper mapHtml={hotelDetails?.map} height="200px" width="100%" />



              </div>

              <div className="hotelDetail-dealBox">
                <span className="hotelDetail-dealTitle">Last Minute deal</span>
                <p className="hotelDetail-dealText">
                  Congrats! You are getting a discount of ₹826 as a Last Minute
                  Deal offered by the property. Limited time offer only!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='reviews_ratings' style={{ margin: "auto", marginTop: "20px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px", borderRadius: "8px", backgroundColor: "white" }}>
        <div style={{ backgroundColor: "#F9F6F1", padding: "20px", marginTop: "10px" }}>
          <h4 style={{ }}>Customer Reviews & Ratings</h4>
          <hr style={{margin: "auto", marginBottom: "20px" }} />



{/* review container */}
 <div className="review-card-uni">
  <div style={{display: "flex", gap: "20px",flexDirection:"column", alignItems:"center",width:"100%"}}>
    {hotelreviews.length === 0 ? <h4>No Reviews Yet</h4> : hotelreviews.map((review) => (
  <div className='review-card-left-uni' style={{width:"100%"}}>
      <div className="review-card-header-uni">
        <img
          src={humanImg}
          alt="User photo"
          className="review-card-avatar-uni"
        />
        <div className="review-card-userinfo-uni">
          <h3 className="review-card-name-uni">{review?.user?.name}</h3>
          <div
            className="review-card-stars-uni"
            aria-label="5 star rating"
          >
            {[...Array(review?.rating)].map((_, i) => (
              <svg
                key={i}
                viewBox="0 0 20 20"
                className="star-uni"
              >
                <path d="M10 1.6l1.9 4 4.4.6-3.2 3 0.8 4.3L10 12.8 6.1 13.5l0.8-4.3L3.7 6.2l4.4-.6L10 1.6z" />
              </svg>
            ))}
          </div>
        </div>
      </div>

      <p className="review-card-text-uni">
       {review?.comment}
      </p>

  </div>
      ))}


  </div>


      {/* Flipkart-style range bars */}
      
      <div className="review-card-breakdown-uni">
        <div style={{display:"flex", gap:"10px",width:"30%",flexDirection:"column",alignItems:"center"}}>
          <span style={{fontSize:"1.5rem",fontWeight:'600'}}>{totalRatings? (totalRatings/(hotelreviews.length)).toFixed(1): "0"}★</span>
          <span style={{fontSize:"0.7rem",margin:"0px"}}>{hotelreviews.length} Reviews&</span>
          <span style={{fontSize:"0.7rem",margin:"0px"}}>{totalRatings} Ratings</span>
        </div>
        <div style={{display:"flex", flexDirection:"column", gap:"10px",width:"100%"}}>
        <div className="review-card-row-uni">
          <span className="review-card-label-uni">5★</span>
          <div className="review-card-barwrap-uni">
            <div
              className="review-card-bar-uni"
              style={{ width: `${hotelreviews.length >0 ? (hotelreviews.filter(r => r.rating === 5).length / hotelreviews.length).toFixed(1)*100 :0}%` }}
            ></div>
          </div>
          <span className="review-card-percent-uni">{hotelreviews.length >0 ? (((hotelreviews.filter(r => r.rating === 5).length / hotelreviews.length)*100).toFixed(1)) :0}%</span>
        </div>

        <div className="review-card-row-uni">
          <span className="review-card-label-uni">4★</span>
          <div className="review-card-barwrap-uni">
            <div
              className="review-card-bar-uni"
              style={{ width: `${hotelreviews.length >0 ? (hotelreviews.filter(r => r.rating === 4).length / hotelreviews.length) * 100 :0}%` }}
            ></div>
          </div>
          <span className="review-card-percent-uni">{hotelreviews.length >0 ? ((hotelreviews.filter(r => r.rating === 4).length / hotelreviews.length) * 100).toFixed(1) :0}%</span>
        </div>

        <div className="review-card-row-uni">
          <span className="review-card-label-uni">3★</span>
          <div className="review-card-barwrap-uni">
            <div
              className="review-card-bar-uni"
              style={{ width: `${hotelreviews.length >0 ? (hotelreviews.filter(r => r.rating === 3).length / hotelreviews.length) * 100 :0}%` }}
            ></div>
          </div>
          <span className="review-card-percent-uni">{hotelreviews.length >0 ? ((hotelreviews.filter(r => r.rating === 3).length / hotelreviews.length) * 100).toFixed(1) :0}%</span>
        </div>

        <div className="review-card-row-uni">
          <span className="review-card-label-uni">2★</span>
          <div className="review-card-barwrap-uni">
            <div
              className="review-card-bar-uni"
              style={{ width: `${hotelreviews.length >0 ? (hotelreviews.filter(r => r.rating === 2).length / hotelreviews.length) * 100 :0}%` }}
            ></div>
          </div>
          <span className="review-card-percent-uni">{hotelreviews.length >0 ? ((hotelreviews.filter(r => r.rating === 2).length / hotelreviews.length) * 100).toFixed(1) :0}%</span>
        </div>

        <div className="review-card-row-uni">
          <span className="review-card-label-uni">1★</span>
          <div className="review-card-barwrap-uni">
            <div
              className="review-card-bar-uni"
              style={{ width: `${hotelreviews.length >0 ? (hotelreviews.filter(r => r.rating === 1).length / hotelreviews.length) * 100 :0}%` }}
            ></div>
          </div>
          <span className="review-card-percent-uni">{hotelreviews.length >0 ? ((hotelreviews.filter(r => r.rating === 1).length / hotelreviews.length) * 100).toFixed(1) :0}%</span>
        </div>
        </div>

      </div>
    </div>
          
        </div>

      </div>

      <section className="hotel-rules-wrapper">
      <div className="hotel-rules-container">
        <h1 className="hotel-rules-title">
          🏨 Room Occupancy & Child Policy
        </h1>
        <p className="hotel-rules-subtitle">
          (Hotel Rules & Regulations)
        </p>

        {/* Occupancy Policy */}
        <div className="rules-card fade-in">
          <h4>🛏️ रूम ऑक्यूपेंसी पॉलिसी</h4>
          <ul>
            <li>सभी कमरों में Base Occupancy 2 Adults रहेगी (Family Room को छोड़कर)।</li>
            <li>Extra Bed / Mattress केवल उपलब्ध स्थान के अनुसार और Chargeable रहेगा।</li>
            <li>Fire & Safety नियमों के अनुसार Maximum Occupancy से अधिक अनुमति नहीं होगी।</li>
          </ul>
        </div>

        {/* Room Capacity */}
        <div className="rules-card slide-up">
          <h4>🏨 Room Category Wise Capacity</h4>

          <div className="capacity-grid">
            <div className="capacity-box">
              <h5>Standard / Deluxe / Super Deluxe / Executive</h5>
              <p>Base: 2 Adults</p>
              <p>Extra Bed: 1 Adult</p>
              <p>Extra Child: 1 (Without Bed)</p>
              <strong>Max: 3 Adults OR 2 Adults + 1 Child</strong>
            </div>

            <div className="capacity-box">
              <h5>Family Room</h5>
              <p>Base: 4 Adults</p>
              <p>Extra Bed: 1 Adult</p>
              <p>Extra Child: 1–2 Children</p>
              <strong>Max: 5 Adults OR 4 Adults + 1–2 Children</strong>
            </div>

            <div className="capacity-box">
              <h5>Suite Room</h5>
              <p>Base: 2 Adults</p>
              <p>Extra Bed: Up to 2 Adults</p>
              <p>Extra Child: Up to 2 Children</p>
              <strong>Max: 4 Adults + 2 Children</strong>
            </div>
          </div>
        </div>

        {/* Child Policy */}
        <div className="rules-card fade-in">
          <h4>👶 Child Policy</h4>
          <ul>
            <li>0–5 Years: Free (Without Bed)</li>
            <li>5–10 Years: Child charges applicable (Without Bed / Extra Mattress)</li>
            <li>Above 10 Years: Considered Adult (Extra Bed charges apply)</li>
          </ul>
        </div>

        {/* Extra Bed Policy */}
        <div className="rules-card slide-up">
          <h4>💰 Extra Bed Policy</h4>
          <ul>
            <li>Extra Bed / Mattress chargeable रहेगा।</li>
            <li>Room Size & Availability पर निर्भर करेगा।</li>
            <li>Standard category rooms में केवल 1 Extra Bed अनुमत है।</li>
          </ul>
        </div>

        {/* Important Notes */}
        <div className="rules-card warning">
          <h4>⚠️ Important Notes</h4>
          <ul>
            <li>Room sharing केवल Registered Guests के लिए अनुमत है।</li>
            <li>Overcrowding की स्थिति में होटल Extra Charges / Upgrade / Cancellation कर सकता है।</li>
            <li>Hotel Management का निर्णय अंतिम और मान्य होगा।</li>
          </ul>
        </div>
      </div>
    </section>

    </div>
  )
}

export default HotelDetails